import {
  withCompInfo,
  createComponentMapperModel,
} from '@wix/editor-elements-integrations';
import { LoginSocialBarSdkData } from '@wix/thunderbolt-components';
import {
  LoginSocialBarPlatformProps,
  LoginSocialBarDefinition,
  LoginSocialBarCSSVars,
} from '../LoginSocialBar.types';

export const props = withCompInfo<
  LoginSocialBarPlatformProps,
  LoginSocialBarDefinition,
  LoginSocialBarPlatformProps
>()(['compProps', 'experiments'], ({ compProps, experiments }, carmiData) => {
  return {
    ...carmiData,
    arrowShape: compProps.arrowShape,
    arrowSize: compProps.arrowSize,
    showBellIcon: compProps.showBellIcon,
    experiments,
    isNewLoginSocialBarStylesEnabled:
      experiments['specs.thunderbolt.LoginSocialBarNewStyles'],
    menuItemsAlignment: compProps.dropDownTextAlignment,
  };
});

export const css = withCompInfo<
  LoginSocialBarCSSVars,
  LoginSocialBarDefinition,
  LoginSocialBarCSSVars
>()(['compProps'], ({ compProps }, carmiCss) => {
  return { ...carmiCss, '--arrow-size': `${compProps.arrowSize}px` };
});

export const sdkData = withCompInfo<
  LoginSocialBarSdkData,
  LoginSocialBarDefinition,
  LoginSocialBarSdkData
>()([], (_deps, carmiSdkData) => {
  return carmiSdkData;
});

export default createComponentMapperModel({ props, css, sdkData });
